import { render } from "./Reservas.vue?vue&type=template&id=124786f4&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"comensales\":\"data\"}"
import script from "./Reservas.vue?vue&type=script&lang=js"
export * from "./Reservas.vue?vue&type=script&lang=js"
script.render = render

export default script